import * as React from "react";
import { Table, Typography } from "antd";
import { IDebtObligation } from "../../../../model/report/applicantdata/DebtObligation";
import NumberFormatter from "../../../../model/common/NumberFormatter";

const DebtObligationGrid = ({
  translate,
  data
}: {
  translate?: any;
  data?: IDebtObligation[];
}) => {
  const columns = [
    {
      title: translate(
        "report8.document_template.debt_obligations.debtor_name"
      ),
      dataIndex: "debtorName",
      key: "debtorName"
    },
    {
      title: translate(
        "report8.document_template.debt_obligations.description"
      ),
      dataIndex: "description",
      key: "debtObligationsDescription"
    },
    {
      title: translate("report8.document_template.debt_obligations.creditor"),
      dataIndex: "creditor",
      key: "creditor"
    },
    {
      title: translate("report8.document_template.debt_obligations.debt_value"),
      key: "debtValue",
      align: "right" as "right",
      render: (record) => (
        <div>{NumberFormatter().formatReadOnlyValue(record.debtValue)}</div>
      )
    },
    {
      title: translate(
        "report8.document_template.debt_obligations.debt_period"
      ),
      dataIndex: "debtPeriod",
      key: "debtPeriod"
    },
    {
      title: translate(
        "report8.document_template.debt_obligations.paid_during_last_year"
      ),
      key: "paidDuringLastYear",
      align: "right" as "right",
      render: (record) => (
        <div>
          {NumberFormatter().formatReadOnlyValue(record.paidDuringLastYear)}
        </div>
      )
    },
    {
      title: translate(
        "report8.document_template.debt_obligations.left_to_pay"
      ),
      key: "leftToPay",
      align: "right" as "right",
      render: (record) => (
        <div>{NumberFormatter().formatReadOnlyValue(record.leftToPay)}</div>
      )
    }
  ];
  return (
    <div>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {translate("report8.document_template.debt_obligations.title")}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
        style={{ marginBottom: 15 }}
      />
    </div>
  );
};

export default DebtObligationGrid;
